export const QUIZ_FETCH_START = "QUIZ_FETCH_START"
export const QUIZ_FETCH_SUCCESS = "QUIZ_FETCH_SUCCESS"
export const QUIZ_FETCH_ERROR = "QUIZ_FETCH_ERROR"

export const CURRENT_QUIZ_SUCCESS = "CURRENT_QUIZ_SUCCESS"
export const QUIZ_SET_STATE = "QUIZ_SET_STATE"
export const QUIZ_FINISH = "QUIZ_FINISH"
export const QUIZ_NEXT_QUESTION = "QUIZ_NEXT_QUESTION"
export const QUIZ_RETRY = "QUIZ_RETRY"

export const CREATE_QUESTION = 'CREATE_QUESTION'
export const QUIZ_RESET_CREATE = 'QUIZ_RESET_CREATE'

export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_AUTO_LOGOUT = 'AUTH_AUTO_LOGOUT'